export const DEFAULT_DISPLAY_MODE = 'pc'
export const DEFAULT_CYCLE_TIMEOUT = 5000 // milliseconds
export const DISPLAY_MODE_TV = 'tv' // cycling of pages is enabled
export const DEFAULT_PLAYERS_PER_PAGE = 5 // items
export const DEFAULT_TEAMS_PER_PAGE = 1



// WEBPACK FOOTER //
// ./src/constants/displayMode.tsx